module.exports = __webpack_public_path__ + "img/bg.e2c313e2.png";